import { Component, OnInit } from '@angular/core';
import { LookupScreenService } from '../../../../../../services/lookup-screen.service';
import { DoctorBreadcrumbService } from '../../../../shared/breadcrumb.service';
import { Title } from '@angular/platform-browser';
import { TraceClassDecorator } from '@sentry/angular';
import { DoctorprofileService } from 'src/app/services/doctorprofile.service';
import { ActivatedRoute, Router } from '@angular/router';
import { profileFetch } from 'src/app/models/Doctorprofile';
import { HttpErrorResponse } from '@angular/common/http';
import { ProviderStateService } from 'src/app/services/provider-state.service';

interface doctorsDetails {
    address_line_1: string;
    address_line_2: string;
    avatar_url: string;
    city: string;
    country: {
        acronym: string;
        phone_code: number;
        country_name: string;
    };
    country_id: number;
    d_email: string;
    date_of_birth: string;
    primary_contact_number: string;
    doctor_profile: {
        doctor_guid: string;
        joined_date: string;
        terminated_date: string;
        secondary_contact_number: string;
    };
    joined_date: string;
    terminated_date: string;
    egd_email: string;
    first_name: string;
    gender: string;
    is_active: boolean;
    last_name: string;
    middle_name: string;
    role_id: number;
    state_name: string;
    user_guid: string;
    zip_code: string;
}

@TraceClassDecorator()
@Component({
    selector: 'app-lookup-display-d',
    templateUrl: './lookup-display-d.component.html',
    styleUrls: [
        './lookup-display-d.component.css',
        '../../../../../../../assets/css/custom-egd.css'
    ]
})
export class LookupDisplayDComponent implements OnInit {
    doctor: doctorsDetails = null;
    serverError: any;
    response: any;
    slug: string = "";
    constructor(
        private lookupservice: LookupScreenService,
        private doctorprofileService: DoctorprofileService,
        private breadcrumbService: DoctorBreadcrumbService,
        private router: Router,
        private route: ActivatedRoute,
        private titleService: Title,
        private readonly providerstateService: ProviderStateService
    ) {
    }

    ngOnInit(): void {
        let data: profileFetch = null;
        this.slug = this.providerstateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },
            { label: 'Lookup Screen' },
            { label: 'Lookup Doctors' },
            { label: 'Lookup List' },
            { label: 'Lookup Details' }
        ]);
        this.titleService.setTitle('Dashboard - Doctor Lookup Display');
        this.route.queryParamMap.subscribe((res) => {
            let user_guid = res.get('user_guid');
            data = {
                user_guid: user_guid,
                current_user_guid: sessionStorage.getItem('userid')
            }
        })
        this.doctorprofileService.getDoctorsProfileDataForDoctorDash(data).toPromise().then(
            (res) => {
                if (res.success)
                    this.doctor = res.data.data;

            }
        ).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
        });

    }

    prev() {
        this.router.navigate(['/' + this.slug + '/doctor/lookup-list-d']);
    }
}
